module.exports = __webpack_public_path__ + "frontend/images/faq/screen-payment-view-3d8113e09f81bc2bef3c843882b0559e.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/faq/screen-payment-view.jpg
// module id = 341
// module chunks = 2